// Awaiting-approval state, shown in place of any dashboard.
//
// Lived inside HomePage until the dashboard split in two. It is the
// landing page's job, and the landing page is now My Day — but Firm
// Overview keeps the same guard, because a page reachable by URL
// should not show matter counts to somebody an administrator has not
// approved yet.

import React from "react";
import { C, ROLE_LABELS, ROLE_BADGE_COLORS } from "../constants.js";
import { I } from "../icons.jsx";

export function PendingApprovalCard({ authStatus }) {
  const role = authStatus?.firm_user?.role || "pending";
  return (
    React.createElement("div", {
      className: "fade-in",
      style: { padding: "64px 40px", maxWidth: "560px", margin: "40px auto 0" },
    },
      React.createElement("div", {
        style: {
          background: "#fff", borderRadius: "16px", padding: "48px 40px",
          border: `1px solid ${C.warmGray}`,
          boxShadow: "0 4px 24px rgba(27,42,74,0.08)",
          textAlign: "center",
        },
      },
        React.createElement("div", {
          style: {
            width: 64, height: 64, borderRadius: "50%",
            background: `${C.gold}18`, color: C.gold,
            display: "flex", alignItems: "center", justifyContent: "center",
            margin: "0 auto 24px",
          },
        }, I.clock),
        React.createElement("h1", {
          style: { fontFamily: "'Playfair Display',serif", fontSize: "24px", fontWeight: 700, color: C.navy, marginBottom: "12px" },
        }, "Your account is awaiting approval"),
        React.createElement("p", {
          style: { fontSize: "15px", color: C.textMuted, lineHeight: 1.6, marginBottom: "24px" },
        },
          "You've signed into Clio successfully, but an administrator hasn't assigned you a role yet. Ask your administrator to grant you access from the Users page."),
        authStatus?.user?.email && React.createElement("div", {
          style: {
            background: C.cream, border: `1px solid ${C.warmGray}`,
            borderRadius: "10px", padding: "14px 18px",
            marginBottom: "20px", textAlign: "left",
          },
        },
          React.createElement("div", {
            style: { fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.06em", fontWeight: 600, color: C.textMuted, marginBottom: "4px" },
          }, "Signed in as"),
          React.createElement("div", { style: { fontSize: "14px", color: C.navy, fontWeight: 600 } },
            authStatus.user.name || "(no name)"),
          React.createElement("div", { style: { fontSize: "13px", color: C.textMuted, wordBreak: "break-all" } },
            authStatus.user.email),
        ),
        React.createElement("div", {
          style: {
            display: "inline-flex", alignItems: "center", gap: "8px",
            padding: "6px 14px", borderRadius: "9999px",
            background: (ROLE_BADGE_COLORS[role] || ROLE_BADGE_COLORS.pending).bg,
            color: (ROLE_BADGE_COLORS[role] || ROLE_BADGE_COLORS.pending).fg,
            fontSize: "11px", fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase",
          },
        },
          React.createElement("span", { style: { width: 6, height: 6, borderRadius: "50%", background: (ROLE_BADGE_COLORS[role] || ROLE_BADGE_COLORS.pending).fg } }),
          "Current role: ", ROLE_LABELS[role] || role,
        ),
        React.createElement("p", {
          style: { fontSize: "12px", color: C.textLight, lineHeight: 1.5, marginTop: "28px", paddingTop: "20px", borderTop: `1px solid ${C.warmGray}` },
        }, "Once approved, refresh this page — you'll see the full dashboard."),
      ),
    )
  );
}
